var chunkToChildrenMap = {
	"5385": [
		8656,
		8715,
		1869,
		5109,
		2702
	]
};
__webpack_require__.f.preload = (chunkId) => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.G);
};